import { memo } from "react";

export const CountryFlag = memo(
  ({
    countryCode,
    getFlag,
  }: {
    countryCode: string;
    getFlag: (name: string) => string | undefined;
  }) => {
    const url = getFlag(countryCode);

    return <img aria-hidden className="flag" {...(url ? { src: url } : {})} />;
  }
);
CountryFlag.displayName = "CountryFlag";
